import React, { useState, useRef } from 'react';
import { MDBFooter, MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";

export const Footer = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    email_id: '',
    message: '',
  });

  const [validated, setValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const recaptchaRef = useRef(null);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const form = e.currentTarget;

    if (form.checkValidity() === false || !recaptchaValue) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    setIsSubmitting(true);

    const serviceId = 'service_mxk20ep';
    const templateId = 'template_xamsely';
    const userId = 'aImxa9UKM7m_PvF29';

    emailjs.send(serviceId, templateId, formData, userId)
      .then((response) => {
        console.log('Email sent successfully:', response);

 
        setShowSuccess(true);


        setFormData({
          first_name: '',
          email_id: '',
          message: '',
        });
        setRecaptchaValue(null);
        recaptchaRef.current.reset();

     
        setTimeout(() => setShowSuccess(false), 5000);
      })
      .catch((error) => {
        console.error('Error sending email:', error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <section className='footer' id="contact">
      <div>
        <h1>CONTACT US</h1>
        <p>Please don't hesitate to send us a message if you have any questions. We are here to help and would be delighted to assist you with any inquiries you may have.</p>
      </div>

      <div className="footer" id="contacto">
        <MDBFooter className='text-body text-center text-lg-left '>
          <MDBContainer className='p-4' style={{ maxWidth: '700px' }}>
            <MDBRow>
              <MDBCol lg='5' md='12' className='mb-4 mb-md-0' id="infoFooter">
                <div className='contactInfo'>
                  <div className='logo-footer'>
                    <img className='logoFooter' src="/img/sekemWhite.png" alt="Logo" style={{ width: '170px' }} />
                  </div>
                  <div className='info-email'>
                    <h4 style={{ marginBottom: '0.3rem' }}>Email to us</h4>
                    <h6 style={{ marginBottom: '0.2rem' }}>sales@sekem.co.nz</h6>
                  </div>
                </div>
              </MDBCol>

              <MDBCol lg='7' md='12' className='mb-4 mb-md-0'>
                <div className='registerForm'>
                  <div className='formApply'>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                      <Form.Group className="mb-4" as={Col} controlId="validationCustom01">
                        <Form.Control
                          required
                          type="text"
                          placeholder="Name"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please write your name.
                        </Form.Control.Feedback>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-4" as={Col} controlId="validationCustomUsername">
                        <InputGroup hasValidation>
                          <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                          <Form.Control
                            type="email"
                            placeholder="Email"
                            aria-describedby="inputGroupPrepend"
                            required
                            name="email_id"
                            value={formData.email_id}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                          </Form.Control.Feedback>
                          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group className="mb-4" as={Col} controlId="message">
                        <InputGroup hasValidation>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            type="text"
                            placeholder="Message"
                            aria-describedby="inputGroupPrepend"
                            name="message"
                            required
                            value={formData.message}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please write a message.
                          </Form.Control.Feedback>
                          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group
                        className="mb-3 d-flex justify-content-end"
                        controlId="checkBox1"
                        style={{ color: "white" }}
                      >
                        <ReCAPTCHA
                          sitekey='6LduSEorAAAAACmXCyNXCLrT8Jcsrg3LTFR8EswP'
                          // sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA'
                          onChange={handleRecaptchaChange}
                          ref={recaptchaRef}
                        />
                      </Form.Group>

                      <div className='btnForm' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          id="btn"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Sending...' : 'Send'}
                        </Button>
                      </div>
                    </Form>

        
                    {showSuccess && (
                      <div
                        className="alert alert-success mt-4"
                        role="alert"
                        style={{ textAlign: 'center', fontSize: '18px' }}
                      >
                        Thanks for getting in touch! We'll get back to you soon.
                      </div>
                    )}
                  </div>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBCol lg='11' md='11' className='mb-4 mb-md-4' id="links-footer">
              <br />
              <ul className='list-unstyled d-flex justify-content-center flex-wrap links-container text-center' id="listFooter">
                <li className="link-item"><a href='#brand' className='linkFooter'>BRAND</a></li>
                <li className="link-item"><a href='#aboutUs' className='linkFooter'>ABOUT US</a></li>
                <li className="link-item"><a href='#stockist' className='linkFooter'>STOCKIST</a></li>
                <li className="link-item"><a href='#catalogue' className='linkFooter'>CATALOGUE</a></li>
                <li className="link-item"><a href="https://shop.sekem.co.nz" className='linkFooter' target="_blank">WHOLESALE ORDERING LOGIN</a></li>
              </ul>
            </MDBCol>
          </MDBContainer>
        </MDBFooter>

        <div className='text-center p-3' style={{ backgroundColor: 'rgba(31,40,87)', color: "white" }}>
          Website crafted by <a href="https://www.natalilarroza.com" target="_blank" rel="noopener noreferrer" style={{ color: "white", fontWeight: "bold", textDecoration: "none" }}>
            Natali Larroza
          </a> | &copy; {new Date().getFullYear()} Sekem
        </div>
      </div>
    </section>
  );
};

export default Footer;